import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import './styles/index.css';
import App from './App.jsx';

// Sentry error monitoring — only active when VITE_SENTRY_DSN is set.
// Get your DSN from sentry.io → Project → Settings → Client Keys.
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE, // "production" | "development"
    // Capture 100% of errors, 10% of performance traces
    tracesSampleRate: 0.1,
    // Session replay — captures 10% of sessions, 100% of sessions with errors
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Only report errors from production builds
    enabled: import.meta.env.PROD,
  });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <Sentry.ErrorBoundary
        fallback={
          <div
            style={{
              padding: '40px',
              textAlign: 'center',
              fontFamily: 'Georgia, serif',
            }}
          >
            <h1 style={{ color: '#1a1208' }}>Something went wrong</h1>
            <p style={{ color: '#5a5040' }}>
              Please refresh the page or try again later.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                marginTop: '16px',
                padding: '10px 24px',
                background: '#1a1208',
                color: '#F9F2E9',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontFamily: 'Georgia, serif',
              }}
            >
              Refresh Page
            </button>
          </div>
        }
      >
        <App />
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  </StrictMode>,
);
